var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"user-profile-picture",class:_vm.hideCommunityOnCollapse ? 'hide-on-collapse' : '',on:{"click":function($event){return _vm.$emit('toggleProfileModal')}}},[_c('img',{attrs:{"src":_vm.profilePictureUrl,"alt":_vm.memberName}})])
}
var staticRenderFns = []

export { render, staticRenderFns }